import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceHeartEyesIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.134 1 1 4.13403 1 8C1 11.866 4.134 15 8 15ZM6.00616 10.4218C6 10.4606 6 10.5071 6 10.6V11C6 12.1046 6.89542 13 8 13C9.10458 13 10 12.1046 10 11V10.6C10 10.5457 10 10.5072 9.99878 10.4769C9.99789 10.4553 9.9964 10.4379 9.99384 10.4218C9.95996 10.2078 9.79218 10.04 9.57822 10.0062C9.53934 10 9.49289 10 9.39999 10H6.60001C6.50711 10 6.46066 10 6.42178 10.0062C6.20782 10.04 6.04004 10.2078 6.00616 10.4218ZM2.73361 5.22803C2.03061 5.61176 1.79114 6.46393 2.1987 7.13141C2.87939 8.24615 4.82321 8.78107 5.79538 8.98492C6.12732 9.0545 6.45087 8.87787 6.5531 8.57129C6.85251 7.67334 7.33447 5.81421 6.65378 4.69946C6.24619 4.03198 5.34589 3.802 4.64291 4.18573C4.35153 4.34479 4.29364 4.80981 4.24646 5.18866C4.23209 5.30414 4.21872 5.41162 4.20001 5.5C4.16946 5.49023 4.13693 5.479 4.10278 5.46674C4.0488 5.44727 3.99069 5.42523 3.92969 5.4021C3.54129 5.25464 3.03619 5.06287 2.73361 5.22803ZM13.8013 7.13141C14.2089 6.46393 13.9694 5.61176 13.2664 5.22803C12.9638 5.06287 12.4587 5.25464 12.0703 5.4021C11.9707 5.43988 11.8788 5.47479 11.8 5.5C11.7813 5.41162 11.7679 5.30414 11.7535 5.18866C11.7064 4.80981 11.6485 4.34479 11.3571 4.18573C10.6541 3.802 9.75381 4.03198 9.34622 4.69946C8.66553 5.81421 9.14749 7.67334 9.4469 8.57129C9.54913 8.87787 9.87268 9.0545 10.2046 8.98492C11.1768 8.78107 13.1206 8.24615 13.8013 7.13141Z"
			/>
		</svg>
	),
)
